// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveAnnouncementDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import AnnouncementDTO from '../models/AnnouncementDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    announcementId: string | null;
    announcement: AnnouncementDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            announcementId: '00000000-0000-0000-0000-000000000000',
            announcement: null,
        },
        initValues);
    },
    announcementId: 'announcementId',
    announcement: 'announcement',
}

interface Result extends ResultDTO {
    announcementId: string | null;
    announcement: AnnouncementDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            announcementId: '00000000-0000-0000-0000-000000000000',
            announcement: null,
        },
        initValues);
    },
    announcementId: 'announcementId',
    announcement: 'announcement',
}

export { Request, Result };